import { render, staticRenderFns } from "./VirtualSelect.ts.vue?vue&type=template&id=3dd765a5&"
import script from "./VirtualSelect.ts.vue?vue&type=script&lang=ts&"
export * from "./VirtualSelect.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports